import { IApiResponse } from "../../Orchestrator/Types/Index";
import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { apiRequest } from "../../Lib/Utils/ApiRequest";
import { ISeatingPreferenceResponse } from "../../Orchestrator/Types/Interface/ISeatingPreference";

export async function getSeatingPreferences(): Promise<IApiResponse<ISeatingPreferenceResponse>> {
    const ENDPOINTS = await getEndpoints();
    const endpoint = ENDPOINTS.getSeatingPreferences;
    return await apiRequest<ISeatingPreferenceResponse>(endpoint, 'GET');
}
